// Joke loader that adds turtles
export const loader = (text: string): string => {
  if (text.length > 25) {
    return "Query is having trouble reaching API or there are no results for query."
  }
  return text + "🐢"
}